<template>
  <div
     v-if="this.$store.state.showModal"
    class="bg-modal-box fixed left-0 right-0 z-[99999] w-100vw h-100vh top-0"
  >
    <div
      class="modal-box fixed rounded-[8px] bg-white md:w-[650px] text-center left-0 right-0 z-[99999] mx-auto pt-[60px] pb-[40px] top-1/2"
    >
      <div class="font-medium text-[22px]">
        Ups! Przepraszamy, ale wystąpił problem techniczny. <br />
        Odczekaj chwilę i ponów kalkulację.
      </div>
      <div class="my-[30px]">
        Jeśli nie chcesz czekać:
      </div>
      <div class="flex">
        <div class="w-1/2 text-center">
          <img
            src="@/assets/img/punkta_comparer/phone 1.svg"
            class="inline-block"
            alt=""
          />
          <div class="mt-[22px]">
            Zadzwoń: <a href="tel:+224909000"><strong>22 490 90 00</strong></a>
          </div>
        </div>
        <div class="w-1/2 text-center">
          <img
            src="@/assets/img/punkta_comparer/arroba 1.svg"
            class="inline-block"
            alt=""
          />
          <div class="mt-[22px]">
            Napisz:
            <a href="mailto:kontakt@punkta.pl"
              ><strong>kontakt@punkta.pl </strong></a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  data () {
    return {}
  }
}
</script>
